import {
  SignUpENTRequestData,
  SignUpProspectENTRequestData,
  SignUpResponse,
} from '../../../../../../types/api/endpoints/auth/register.types';
import { AUTH_ENDPOINTS } from '../../../../../../utils/api/endpoints/authEndpoints';
import { RegisterSignUpQueryParams } from './RegisterSignUpStepForm.types';

const PREFIX = '[registerSignUpQuery]';

export const REGISTER_SIGN_UP_QUERY_KEY = 'REGISTER_SIGN_UP';

export const registerSignUpQuery = async ({ email, password, role }: RegisterSignUpQueryParams) => {
  console.log(PREFIX, `Requesting user account creation...`);
  const response = await AUTH_ENDPOINTS.signUp({ email, password, role });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as SignUpResponse;
};

const ENT_PREFIX = '[registerSignUpENTQuery]';

export const REGISTER_SIGN_UP_ENT_QUERY_KEY = 'REGISTER_SIGN_UP_ENT';

export const registerSignUpENTQuery = async ({ email, password }: SignUpENTRequestData) => {
  console.log(ENT_PREFIX, `Requesting user ENT account creation...`);
  const response = await AUTH_ENDPOINTS.signUpENT({ email, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(ENT_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(ENT_PREFIX, `Received user ENT account creation.`);
  return json as SignUpResponse;
};

const PROSPECT_ENT_PREFIX = '[registerSignUpProspectENTQuery]';

export const REGISTER_SIGN_UP_PROSPECT_ENT_QUERY_KEY = 'REGISTER_SIGN_UP_PROSPECT_ENT';

export const registerSignUpProspectENTQuery = async ({
  email,
  password,
  referrer,
}: SignUpProspectENTRequestData) => {
  console.log(PROSPECT_ENT_PREFIX, `Requesting prospect ENT account creation...`);
  const response = await AUTH_ENDPOINTS.signUpProspectENT({ email, password, referrer });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PROSPECT_ENT_PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PROSPECT_ENT_PREFIX, `Received prospect ENT account creation.`);
  return json as SignUpResponse;
};
